import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useRef } from 'react';
const Checkbox = ({ id, label, labelColor = '#7c818c', labelFontSize = 'default', checked, onChange, }) => {
    const ref = useRef(null);
    useEffect(() => {
        if (ref?.current) {
            ref.current.indeterminate = checked === undefined;
        }
    }, [checked]);
    return (_jsxs("div", { className: `checkbox font--${labelFontSize}`, children: [_jsx("input", { ref: ref, type: "checkbox", id: id, checked: checked !== undefined ? checked : false, onChange: onChange }), _jsxs("label", { htmlFor: id, style: labelColor ? { color: labelColor } : undefined, children: [_jsx("span", {}), _jsx("span", { children: label })] })] }));
};
export default Checkbox;
